import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  <SelectedChoice
  @item={{this.item}}
  @selectKit={{this.selectKit}}
  @extraClass={{this.extraClass}}
>
  {{this.badge}}
</SelectedChoice>
*/
{
  "id": "JIk8Of+8",
  "block": "[[[8,[39,0],null,[[\"@item\",\"@selectKit\",\"@extraClass\"],[[30,0,[\"item\"]],[30,0,[\"selectKit\"]],[30,0,[\"extraClass\"]]]],[[\"default\"],[[[[1,\"\\n  \"],[1,[30,0,[\"badge\"]]],[1,\"\\n\"]],[]]]]]],[],false,[\"selected-choice\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-packages/select-kit.dd9a86fe/node_modules/select-kit/components/selected-choice-category.hbs",
  "isStrictMode": false
});